import { Button, Modal } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import './bookingsub.scss';
import { useEffect, useState } from 'react';
import toast, { NotifyType } from 'utils/toast';
import { FeedBackModel } from 'interface/FeedBack';
import { AppState } from 'interface/stateApp';
import { sendFeedBackResponse } from 'service/feedBackService';
import { BookingSub } from 'interface/BookingSub';
import { updateBookingSubById } from 'service/bookingSubService';
import { convertDateTime } from 'utils/helper';
import { BOOKING_SUB_STATUS } from 'utils/data';

interface FormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  updateData?: any;
  data?: BookingSub | null;
}

function BookingSubModal({ stateApp, setStateApp, data, updateData }: FormProps) {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [bookingSub, setBookingSub] = useState<Partial<BookingSub>>({});

  useEffect(() => {
    if (data) {
      setBookingSub(data);
    }
  }, [data]);

  const { showBookingSubForm } = stateApp;

  const handleSubmit = async () => {
    const data = {...bookingSub,status: BOOKING_SUB_STATUS.CLOSE}
    updateBookingSubById(bookingSub?.id, data as BookingSub)
      .then((response) => {
        if (updateData) {
          toast(NotifyType.SUCCESS, 'Cập nhật thành công!');
          updateData();
          setStateApp({...stateApp,showBookingSubForm: false})
        }
      })
      .catch((error) => {
        toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
        setStateApp({ ...stateApp, showFeedBack: false });
      });
  };

  return (
    <>
      <Modal
        visible={showBookingSubForm}
        onCancel={() =>
          setStateApp({
            ...stateApp,
            showBookingSubForm: false,
          })
        }
        footer={[]}
        className="!rounded-full"
      >
        {/* Feedback Form */}
        <div className="space-y-4 rounded-lg feedback-container p-4">
          <div className="text-[24px] border-b border-gray-300 pb-2">
            <MailOutlined className="text-primary" /> Thông tin đăng ký sách
          </div>

          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Tên người dùng
            </label>
            <div className="w-full custom-select">
              {bookingSub?.nameUser || "Chưa có thông tin"}
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Email
            </label>
            <div className="w-full custom-select text-bodytext2 px-2">
              {bookingSub?.email || "Chưa có thông tin"}
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Số điện thoại
            </label>
            <div className="w-full custom-select text-bodytext2 px-2">
              {bookingSub?.phone || "Chưa có thông tin"}
            </div>
          </div>

          {/* Book Name */}
          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Sách đăng ký
            </label>
            <div className="w-full custom-select">
              {bookingSub?.book?.name || "Chưa chọn sản phẩm"}
            </div>
          </div>

          {/* Book Code */}
          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Mã sách
            </label>
            <div className="w-full custom-select">
              {bookingSub?.book?.code || "Không có mã sản phẩm"}
            </div>
          </div>

          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Thời gian đăng ký
            </label>
            <div className="w-full custom-select">
              {bookingSub?.createdAt !== null ? convertDateTime(bookingSub.createdAt) : null}
            </div>
          </div>

          {/* <div className="rounded-lg">
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Phản hồi
            </label>
            <textarea
              placeholder="Điền nội dung phản hồi của bạn tại đây"
              className="rounded-2xl w-full p-2 resize-none border border-[#919191] outline-none"
              rows={4}
              value={bookingSub?.adminResponse || ""}
              onChange={(e) => setBookingSub({ ...bookingSub, adminResponse: e.target.value })}
            />
          </div> */}

          <Button
            key="submit"
            type="primary"
            className="bg-primary text-white rounded-full w-full py-4"
            onClick={handleSubmit}
          >
            Kết thúc yêu cầu
          </Button>
        </div>

      </Modal>
    </>
  );
}

export default BookingSubModal;
